"use client";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const CategoryGrid = ({ categories }) => {
  const navigate = useNavigate();

  const handleNavigatePost = (id) => {
    navigate(`/app/topics/${id}/posts`)
  }
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {categories.map((topic, index) => (
        <div
          key={index}
          className="flex flex-col p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow"
          onClick={() => {
            handleNavigatePost(topic.id)
          }}
        >
          <div className="flex items-center gap-3 mb-3">
            <div className="flex justify-center items-center p-3 bg-rose-600 rounded">
              {index + 1}
            </div>
            <h3 className="text-lg font-semibold text-gray-700">
              {topic?.title}
            </h3>
          </div>

          <div className="flex items-center gap-2 mb-2">
            <span className="text-sm font-medium text-gray-500">Tổng số bài viết:</span>
            <span className="text-sm font-semibold text-blue-600">
              {topic?.totalPost}
            </span>
          </div>

          {/* <div className="mt-auto pt-3 border-t border-gray-100">
            <h4 className="text-sm font-semibold text-blue-500 mb-1 line-clamp-1">
              123
            </h4>
            <div className="flex items-center text-xs text-gray-500">
              <span>by</span>
              <span className="ml-1 text-blue-500 font-medium">
                123
              </span>
              <span className="mx-1">•</span>
              <span>123</span>
              <span className="mx-1">•</span>
              <span>123</span>
            </div>
          </div> */}
        </div>
      ))}
    </div>
  );
};

export default CategoryGrid;
